var _props = {
  title: 'About Sampson B2B',
  name: 'about',
  "_sname": "About Us",
  slist:['aboutInfo', 'productsIncludes'],
  content:`<p>Sampson Distribution sells and markets sexual well-being products from major reliable, authentic and reputable suppliers/brand owners. Both retailers and non-government organization (NGO) sectors are our target customers for retail and bulk packaging products.</p>`
}

import Vue from 'vue'
import VueResource from 'vue-resource'
import VueCookie from 'vue-cookie';
Vue.use(VueResource);
Vue.use(VueCookie);

import header from '../../components/Header'
import mainbody from '../../components/MainBody'
import utils from '../../components/Utils.vue'

var locale = utils.getLocale();
if (locale == null) {
  locale = "?";
} else {
  locale = '?locale='+locale;
}
locale = locale + '&pagename=aboutus';

//console.log(utils.getQueryString(), utils.getLocale(), utils.getQueryString());
Vue.http.get('json/about.json'+locale).then(response => {
  var props = JSON.parse(response.bodyText);

  Vue.http.get(utils.getServerPath()+'/misc/data.is'+locale).then(response => {
    var data = JSON.parse(response.bodyText);
    if (!props.info) {
      props.info = {};
    }
    Object.keys(data).forEach(function(key) {
      props.info[key] = data[key];
    });

    new Vue({ // eslint-disable-line no-new
      el: '#header',
      render: function(h) {
        if (props.info.common_res != null) {
          return h(header, {props:{name:props.name, header_text:props.info.common_res.header_text}});
        } else {
          return h(header, {props:{name:props.name}});
        }
      }
    })
  
    new Vue({ // eslint-disable-line no-new
      el: '#mainbody',
      created: function() {
        var self = this;
      },
      render: function(h) {
        return h(mainbody, {props:props});
      }
    })
  });
}, response => {
});



// WEBPACK FOOTER //
// ./src/pages/misc/about.js